<template>
  <v-app
    color="teal"
    width='100%'
  >
    <!-- <p>{{GET_AFTE_SEND_FORM }}</p> -->
    <v-main class="teal  d-flex align-center ">
      <div v-if="!GET_ERROR && !GET_LOAD">
        <v-container>

          <!-- После отправки формы -->
          <div
            v-if="GET_AFTE_SEND_FORM"
            class="text-center"
          >

            <h3 class="white--text text-center">
              Дякуємо, {{GET_CLINT_BITRIX_DATA.name}} ! Форма надіслана успішно 🏆
              <br> Натисніть кнопку нижче, щоб перейти в чат з вашим особистим фахівцем</h3>

            <v-btn
              large
              rounded
              color="purple"
              class="white--text text-center go-to-viber"
              :href="`viber://pa?chatURI=teealinfo&context=c${clintBitrixId}`"
            >Перейти у Viber <v-icon
                class="iconViber"
                dark
              >mdi-comment-arrow-right</v-icon>
            </v-btn>

          </div>

          <!-- //После отправки формы -->
          <v-expand-transition>
            <div v-if="!GET_CLINT_BITRIX_DATA.redy && !GET_AFTE_SEND_FORM && !GET_HIDE_HEAD">
              <div v-if="haveClintId">
                <h3 class="white--text text-center">{{GET_CLINT_BITRIX_DATA.hello}}, {{GET_CLINT_BITRIX_DATA.name}}!
                  Це ваша особиста анкета для оформлення та працевлаштування в Польщі.
                  Будь ласка, заповніть усі поля.</h3>
              </div>
            </div>

          </v-expand-transition>

          <div v-if="GET_CLINT_BITRIX_DATA.redy">
            <div
              v-if="haveClintId"
              class="text-center"
            >
              <h3 class="white--text text-center">{{GET_CLINT_BITRIX_DATA.hello}}, {{GET_CLINT_BITRIX_DATA.name}}!
                Ви вже заповнили форму, дякуємо! )
                Натисніть кнопку нижче, щоб перейти в чат з вашим особистим фахівцем</h3>

              <v-btn
                large
                rounded
                color="purple"
                class="white--text text-center go-to-viber"
                :href="`viber://pa?chatURI=teealinfo&context=c${clintBitrixId}`"
              >Перейти у Viber <v-icon
                  class="iconViber"
                  dark
                >mdi-comment-arrow-right</v-icon>
              </v-btn>

            </div>
          </div>

        </v-container>
        <!-- анкета -->
        <div
          class="d-flex  justify-center"
          v-if="!GET_CLINT_BITRIX_DATA.redy && !isCreateClint && !GET_AFTE_SEND_FORM && !GET_LOAD"
        >
          <v-col
            cols="12"
            sm="10"
            md="7"
          >
            <router-view />
            <!-- <router-view @redyForm="AfteSendForm" /> -->
            <!-- <Anketa v-on:redyForm="AfteSendForm"></Anketa> -->

          </v-col>
        </div>

        <!-- //анкета -->
      </div>

      <!-- регистрация -->
      <v-row
        justify="center"
        v-if="!GET_LOAD &&!GET_ERROR"
      >
        <v-dialog
          v-model="isCreateClint"
          persistent
          max-width="600px"
        >

          <v-card>
            <h3 class=" text-center head-registr">

              Анкета для оформлення візи та працевлаштування в Польщі</h3>

            <v-card-text>
              <v-container>
                <v-form v-model="isValidFerst">
                  <v-row>

                    <v-col cols="10">

                      <v-text-field
                        v-model="newClintPhone"
                        name="phone"
                        type="number"
                        label="Введіть ваш номер телефону*"
                        hint="380 ..."
                        :rules="[v => (v && v.length >9)|| 'Має містити від 10 цифр']"
                        required
                        @input="inputPhone"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="2"
                      class="d-flex align-center"
                    >
                      <v-icon
                        v-if="redyInputPhone"
                        large
                        color="green"
                      >mdi-check-circle-outline</v-icon>

                    </v-col>
                    <v-col
                      cols="12"
                      v-if="isAskName"
                    >
                      <v-text-field
                        v-model="newClintLastName"
                        label="Ваше прізвище як в закордонному паспорті"
                        hint="SHEVCHENKO"
                        required
                        :rules="[v => !!v || 'Це обов\'язкове поле']"
                      ></v-text-field>

                      <v-text-field
                        v-model="newClintName"
                        label="Ваше ім'я як в закордонному паспорті"
                        hint="TARAS"
                        required
                        :rules="[v => !!v || 'Це обов\'язкове поле']"
                      ></v-text-field>

                    </v-col>

                  </v-row>
                </v-form>
              </v-container>
              <!-- <small>*indicates required field</small> -->
            </v-card-text>
            <v-card-actions>

              <v-btn
                color="error"
                text
                @click="dialog = false"
              >Відміна</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                large
                class="white--text"
                color="teal "
                :disabled="!isValidFerst"
                @click="createClint"
              >Далі</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <!-- //регистрация -->

      <!-- ошибка -->

      <div v-if="GET_ERROR">
        <h3 class="white--text text-center">Помилка "{{GET_ERROR}}". Будь ласка спробуйте зайти пізніше, або зверніться до вашого фахівця</h3>

      </div>
      <!-- лого -->
      <div class="d-flex  justify-center logoTEEAL align-start ">

        <v-img
          class="logo-partner"
          max-width="40"
          src='/../logo.png'
        ></v-img>
        <span class="white--text desTEEAL">Designed for TEEAL</span>
      </div>
      <div class="d-flex  justify-center  white--text  logoTEEAL">
        <!-- <p>Designed for TEEAL</p> -->
      </div>

      <!-- лого -->

      <v-overlay v-if="GET_LOAD">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>

    </v-main>
  </v-app>
</template>

<script>
import Anketa from "./components/Anketa";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "App",

  // components: {
  //   Anketa
  // },
  data() {
    return {
      managerId: null,
      haveClintId: false,
      clintBitrixId: null,
      isCreateClint: false,
      newClintPhone: null,
      newClintLastName: null,
      newClintName: null,
      isAskName: false,
      redyInputPhone: false,
      isValidFerst: true,
      isAfteSendForm: false
    };
  },

  mounted() {
    const query = this.$route.query;
    // console.log(this.$route);
    if (query.id) {
      //ссылка содержит айди клиента
      //если есть ?id={id}
      this.UPDATE_CLINT_BITRIX_DATA(query.id);
      this.SAVE_CLINT_BITRIX_ID(query.id);
      this.haveClintId = true;
      this.clintBitrixId = query.id;
      //  console.log(query.id);
    } else if (query.managerid) {
      // ссылка содержит айди менеджера
      this.isCreateClint = true;
      this.managerId = query.managerid;
      //если есть ?managerid={managerid}
      //  console.log(query.managerid);
    } else {
      this.CREATE_ERROR("не знайдено ID кліента"); //екшин отправляю ошибку
    }
  },
  methods: {
    ...mapActions([
      "UPDATE_CLINT_BITRIX_DATA", // получает данные оклиенте по айди
      "SEARCH_BITRIX_CLINT", // ищет клиента по номеру телефона
      "CREATE_CLINT", // создает клиента
      "SAVE_CLINT_BITRIX_ID", //записывает айди клиента в стор
      "CREATE_ERROR" // создает ошибку
    ]),
    inputPhone() {
      //поиск клиента по номеру телефона
      const phone = this.newClintPhone;
      if (phone.length >= 10) {
        //когда ввел больше 10 символов
        if (
          (phone[0] == 3 && phone.length == 12) ||
          (phone[0] == 8 && phone.length == 11) ||
          (phone[0] == 0 && phone.length == 10)
        ) {
          this.redyInputPhone = true;
          this.SEARCH_BITRIX_CLINT(phone).then(clintData => {
            if (clintData.status == "emptyContact") {
              this.isAskName = true;
            } else if (clintData.status == "true") {
              this.redirectToPersonalForm(clintData.clintID);
            }
          });
          // console.log(phone);
        } else if (phone.length >= 12) {
          // this.isAskName = true;
        }
      }
    },
    createClint() {
      // через екшин - ищет клиента и возвращет - есть такой или нет
      this.SEARCH_BITRIX_CLINT(this.newClintPhone).then(clintData => {
        if (clintData.status == "emptyContact") {
          this.isAskName = true;
        } else if (clintData.status == "true") {
          this.redirectToPersonalForm(clintData.clintID);
        } else {
          this.isCreateClint = false;
          this.CREATE_ERROR(
            "Помилка, з'єднання з сервером, будь ласка перезавантажте сторінку"
          );
        }
      });

      //создаю клиента по менеджером
      if (this.newClintPhone && this.newClintName && this.newClintLastName) {
        const datanewClint = JSON.stringify({
          phone: this.newClintPhone,
          name: this.newClintName,
          lastNameCont: this.newClintLastName,
          managerID: this.managerId
        });

        this.CREATE_CLINT(datanewClint).then(newClint => {
          this.redirectToPersonalForm(newClint.clintID);
        });
      } else {
        this.isAskName = true;
      }
    },
    redirectToPersonalForm(clintID) {
      this.UPDATE_CLINT_BITRIX_DATA(clintID);
      this.SAVE_CLINT_BITRIX_ID(clintID);
      this.$router.push(`?id=${clintID}`);
      this.isAskName = false;
      this.haveClintId = true;
      this.isCreateClint = false;
      this.clintBitrixId = clintID;
    },
    AfteSendForm(clintID) {
      //  console.log("AfteSendForm");
      this.clintBitrixId = clintID;
      this.haveClintId = false;
      this.isAfteSendForm = true;
    }
  },

  computed: {
    ...mapGetters([
      "GET_CLINT_BITRIX_DATA",
      "GET_ERROR",
      "GET_CLINT_BITRIX_ID",
      "GET_LOAD",
      "GET_AFTE_SEND_FORM",
      "GET_HIDE_HEAD"
    ])
  }
};
</script>

<style scoped>
.go-to-viber {
  margin: 40px 0;
}
.go-to-viber a {
  text-decoration: none;
}

.iconViber {
  margin: 10px;
}

.head-registr {
  padding: 15px;
  font-weight: 400;
}

.logoTEEAL {
  margin-top: 25px;
}

.desTEEAL {
  margin: 8px;
}
</style>
